// See README.md for more info about field configuration

import moment from 'moment'
import _get from 'lodash/get'

import { FIELD_TYPE, REFDATA_MAP, DATE_FORMAT, CHOOSE_DATE } from '@/constants'
import { COUNTYEA } from './droplistData/countyEA'

import { YES_NO } from '@/applicationDefinition/droplistData/boolean'
import { YES_NO_DONOT } from '@/applicationDefinition/droplistData/booleanDontno'


export default [
  {
    label: 'General Information',
    description:
      'Please provide accurate details of the client applying. This information is used to help to process the application.',
    type: FIELD_TYPE.HEADING
  },
 
  {
    apiKey: 'client.phoneNumber',
    label: 'Phone Number', 
    placeHolder: '(123) 456-7890',
    description: "Format: (123) 456-7890",   
    required: true,    
    type: FIELD_TYPE.PHONE,
    maxLength: 14,
    validation(value) {     
      if (!/^\d{10}$/.test(value.replace(/[^a-zA-Z0-9]+/g,''))) {
        return 'Please enter minimum 10 digits.'
      }
    }
  },
  {
    apiKey: 'general.referredBy',
    label:'Who referred you to the Building Blocks of Islam, or how did you hear about us?',
    placeHolder: 'Enter Referral details',
    required: true,
    type: FIELD_TYPE.TEXTAREA,
    maxLength: 100
  },
 
  {
    apiKey: 'general.hasAppliedBefore',
    label:'Have you applied to the Building Blocks’ Online Emergency Assistance (EA) program before?',
    required: true,    
    type: FIELD_TYPE.RADIO,
    options: YES_NO_DONOT
  },
  {
    apiKey: 'general.whenAppliedBefore',
    label:'When did you apply?',
    required: true,
    type: FIELD_TYPE.DATE,
    visible(application) {
      return application.general.hasAppliedBefore  && application.general.hasAppliedBefore != 'NA'    
    },
    validation(value) {
      if (moment(value) > moment()) {
        return 'Cannot be a future date'
      }
    },
  },
  {
    apiKey: 'general.whyAppliedBefore',
    label:'For what purpose did you apply?',
    required: true,
    visible(application) {
      return application.general.hasAppliedBefore  && application.general.hasAppliedBefore != 'NA'     
    },
  },  
  {
    apiKey: 'general.hasHouseHoldAppliedBefore',
    label:'Has anyone in your household applied for the Building Blocks EA program before?',
    required: true,
    type: FIELD_TYPE.RADIO,
    options: YES_NO_DONOT
  },
  {
    apiKey: 'general.whenHouseHoldAppliedBefore',
    label:'When did they apply?',
    required: true,
    type: FIELD_TYPE.DATE,
    visible(application) {
      return application.general.hasHouseHoldAppliedBefore  && application.general.hasHouseHoldAppliedBefore != 'NA'     
    },
    validation(value) {
      if (moment(value) > moment()) {
        return 'Cannot be a future date'
      }
    },
  },
  {
    apiKey: 'general.whyHouseHoldAppliedBefore',
    label:'For what purpose did they apply?',
    required: true,
    visible(application) {
      return application.general.hasHouseHoldAppliedBefore  && application.general.hasHouseHoldAppliedBefore != 'NA'     
    },
  },    
  {
    apiKey: 'general.hasCommunityAssistance',
    label:'Have you reached out to any other community resources for assistance?',
    required: true,
    type: FIELD_TYPE.RADIO,
    options: YES_NO
  },
  {
    apiKey: 'general.otherCommunityAssistance',
    label:'List the other community resources that have been contacted for help',
    required: true,
    visible(application) {
      return application.general.hasCommunityAssistance      
    }   
  },
  {
    apiKey: 'general.financialCrisis',
    label:'Are any of them able to help with this current financial crisis?',
    required: true,
    visible(application) {
      return application.general.hasCommunityAssistance      
    }    
  },
  
  {
    apiKey: 'general.otherCountyEA.otherCounty',
    label :'Have you applied to your county’s emergency assistance program?',    
    required: true,
    type: FIELD_TYPE.DROPDOWN,
    options: COUNTYEA
     
  }, 
  {
    apiKey: 'general.otherCountyEA.otherCountyApprovedAmount',
    label: 'How much has the county approved you for?',
    placeHolder: 'Please enter a valid number',
    type: FIELD_TYPE.CURRENCY,   
    required: true,
    maxRows: 2,
    visible(application) {
      return application.general.otherCountyEA.otherCounty === 'currentApproved'      
    },
    validation(value) {     
      if (value<=0.00) {
        return 'Please enter valid amount.'
      }
    }
  },
  {
    apiKey: 'general.otherCountyEA.nonEligibilityReason',
    label: 'Why are you not eligible to apply?',
    required: true,  
    visible(application) {
      return application.general.otherCountyEA.otherCounty === 'notEligible' 
    }
  },

  {
    apiKey: 'general.housingAssistance',
    label:'Do you receive any housing assistance?',
    required: true,
    type: FIELD_TYPE.RADIO,
    options: YES_NO
  },
  {
    apiKey: 'general.fromAndAmount',
    label:'From where, and for how much?',
    required: true,
    type: FIELD_TYPE.TEXTAREA,
    visible(application) {
      return application.general.housingAssistance      
    }   
  }

]
